<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){

    return{
      isActive:true
    }
  }
}
</script>

<style>
body{
  min-width: 1200px;
  font-family: inherit;
  margin: 0;
  padding: 0;

}

</style>



// WEBPACK FOOTER //
// src/App.vue